import { useEffect, useState } from 'react';

import ModulosEgresados from './Home/ModulosEgresados';
import CardBienvenida from './Home/CardBienvenida';
import { useEgresadoContext } from './../../context/EgresadoProvident';
import InformacionParaEgresados from './../../hooks/hookAvisos';

import functions from './../../shared/functions';
import WelcomeSplash from '../../../../component/WelcomeSplash/WelcomeSplash';

const Home = () => {
  const [progress, setProgress] = useState(0);
  const { alumno, showWelcomeCard, setShowWelcomeCard } = useEgresadoContext();

  const onHiddenCard = () => setShowWelcomeCard(false);

  useEffect(() => {
    if (!alumno) return;
    const progress = functions.getPorcentajeAvanceCV(alumno);
    setProgress(progress);
    if (progress === 100 && InformacionParaEgresados.length === 0) {
      setShowWelcomeCard(false); // Oculta la tarjeta cuando el progreso es 100%
    } else {
      setShowWelcomeCard(true); // Muestra la tarjeta si el progreso es menor a 100%
    }
  }, [alumno]);

  if (showWelcomeCard === null) {
    return <WelcomeSplash isLoading />;
  }

  return (
    <>
      {showWelcomeCard ? <CardBienvenida alumno={alumno} progress={progress} onHiddenCard={onHiddenCard} /> : <ModulosEgresados />}
    </>
  );
};


export default Home;
